import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge className strings intelligently — combines conditional logic
 * from clsx with Tailwind conflict resolution from tailwind-merge.
 *
 * Example:
 *   cn("px-4 py-2", isActive && "bg-brand-500", "px-6")
 *   // → "py-2 bg-brand-500 px-6"   (px-4 overridden by px-6)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
